import * as React from "react";
import { DeviceMenuProps } from "../models/deviceMenuProps";
import Modal from "react-bootstrap/Modal";

interface Props {
  closeModal: () => void;
  deviceMenuProps: DeviceMenuProps,
}

const ContextMenu = (props: Props) => {
  const actions = props.deviceMenuProps.actions || [];
  return (
    <Modal
      show={true}
      size="sm"
      animation={false}
      onEscapeKeyDown={props.closeModal}
      onHide={props.closeModal}
    >
      <div
        className="customer_menu"
        style={{ position: 'fixed', display: 'block', top: `${props.deviceMenuProps.top}px`, left: `${props.deviceMenuProps.left}px` }}
      >
        {actions.map((action, i) => {
          return (
            <div
              key={i}
              onClick={action.do}
            >
              <span>{action.name}</span>
            </div>)
        })}
      </div>
    </Modal>
  );
}

export default ContextMenu